import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross and Blue Shield of Vermont",
  shortName: "Blue Cross VT",
  slug: "blue-cross-vt-insurance",
  seoTitle:
    "Blue Cross and Blue Shield of Vermont TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross and Blue Shield of Vermont policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Blue Cross VT TMS coverage, Blue Cross Blue Shield Vermont SPRAVATO authorization, Blue Cross VT mental health benefits Coral Springs FL, Blue Cross Vermont depression treatment Florida",
};

export const BlueCrossVtInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default BlueCrossVtInsurance;
